export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/60">
          {/* Image */}
          <div className="flex-shrink-0">
            <div className="w-48 md:w-56 rounded-xl overflow-hidden border border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20dark%20theme%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%2C%20cinematic%20red%20and%20gold%20accent%20colors%2C%20clean%20modern%20UI%20design%2C%20minimal%20layout%2C%20premium%20look%2C%20on%20a%20dark%20background%20with%20soft%20warm%20lighting&width=400&height=700&seq=app-mockup-cinema-03&orientation=portrait"
                alt="哈哈影院移动端观影界面"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Text */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold mb-4">
              移动观影
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6">
              哈哈影院手机端完美适配，随时随地打开浏览器即可畅享高清影视。无需下载 App，不占手机存储空间，轻量级网页体验，流量消耗低、加载速度快。支持手势控制亮度与音量，横竖屏自动切换，给您掌上影院般的沉浸式观影体验。
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-3">
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 bg-secondary-100 text-secondary-600 rounded-lg text-xs font-medium">
                <i className="ri-smartphone-line"></i>手机浏览器直达
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 bg-accent-500/10 text-accent-500 rounded-lg text-xs font-medium">
                <i className="ri-speed-up-fill"></i>极速加载
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500/10 text-primary-500 rounded-lg text-xs font-medium">
                <i className="ri-fullscreen-fill"></i>横屏观影
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}